var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotFoundIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_560_1836)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7391 0.0215492L11.1601 0.0815492C8.3506 0.362049 5.5201 1.81105 3.6061 3.95005C1.4896 6.31555 0.414105 9.25105 0.513105 12.3786C0.685605 17.7801 4.39811 22.3535 9.66461 23.6556C11.2152 24.03 12.8247 24.0929 14.3997 23.8405C15.9748 23.5882 17.4841 23.0256 18.8401 22.1856C21.5068 20.524 23.4154 17.8829 24.1561 14.8295C24.4141 13.7781 24.4741 13.2426 24.4741 11.9991C24.4741 10.7556 24.4141 10.22 24.1561 9.16855C22.9681 4.31605 18.9721 0.746049 13.9996 0.0950492C13.5736 0.0395492 12.0241 -0.00995083 11.7391 0.0215492ZM13.7791 2.34355C14.815 2.47636 15.822 2.77891 16.7596 3.23905C17.8066 3.74905 18.5296 4.26805 19.3801 5.11855C20.1604 5.87081 20.7972 6.75877 21.2596 7.73905C21.9271 9.11155 22.2286 10.4361 22.2286 11.9991C22.2491 13.4913 21.9095 14.9665 21.2386 16.2995C20.9806 16.826 20.4601 17.6705 20.2171 17.9571L20.1346 18.0546L13.2901 11.2086L6.4441 4.36405L6.5416 4.28155C6.8281 4.03855 7.6726 3.51805 8.1991 3.26005C9.92593 2.40445 11.8693 2.08525 13.7791 2.34355ZM11.7196 12.8001L18.5596 19.6416L18.4591 19.7211C17.936 20.1074 17.381 20.4486 16.8001 20.7411C15.8602 21.201 14.8548 21.5127 13.8196 21.6651C13.1836 21.7626 11.8156 21.7626 11.1796 21.6651C8.2576 21.2211 5.7916 19.6266 4.2391 17.1756C3.85723 16.5424 3.53869 15.8732 3.2881 15.1776C2.70038 13.4458 2.60228 11.5855 3.0046 9.80155C3.31331 8.51161 3.87184 7.29467 4.6486 6.21955C4.7536 6.07705 4.8481 5.96005 4.8601 5.96005C4.8706 5.96005 7.9576 9.03805 11.7196 12.8001Z",
    fill: "#777777"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_560_1836"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotFoundIcon);
export default __webpack_public_path__ + "static/media/notFound-icon.6aa18b84711d84617868539b839086e3.svg";
export { ForwardRef as ReactComponent };